import moment from 'moment';
import { formatBytes } from '../helpers/formatHelpers';

// Lightweight Model entity wrapper with PascalCase fields only
export default class Model {
  constructor(data) {
    // Expect data to have PascalCase fields (Id, Name, Description, AutomaticExecution, DateColumn, SignalColumn, SignalTags, ActiveSignalTag, FileName, FileSize, CreateTime, UpdateTime, Public, VisibleToUserIds, OwnerName, RealtimeCandlesAutomaticExecutionIntervalInMinutes, SignalCombineMode)
    this.Id = data.Id;
    this.Name = data.Name;
    this.Description = data.Description;
    this.AutomaticExecution = data.AutomaticExecution || false;
    this.SignalTags = data.SignalTags || [];
    this.ActiveSignalTag = data.ActiveSignalTag || null;
    this.FileName = data.FileName;
    this.FileSize = data.FileSize;
    this.Public = data.Public || false;
    this.VisibleToUserIds = data.VisibleToUserIds || null;
    this.OwnerName = data.OwnerName || null;
    this.RealtimeCandlesAutomaticExecutionIntervalInMinutes = data.RealtimeCandlesAutomaticExecutionIntervalInMinutes ?? null;
    this.DefaultPerformanceCalculationId = data.DefaultPerformanceCalculationId ?? null;
    this.SignalCombineMode = data.SignalCombineMode || null;

    // Handle timestamp fields with moment.js
    if (data.CreateTime !== undefined) {
      this.CreateTime = (data.CreateTime === null) ? null : moment.utc(data.CreateTime);
    }

    if (data.UpdateTime !== undefined) {
      this.UpdateTime = (data.UpdateTime === null) ? null : moment.utc(data.UpdateTime);
    }
  }

  // Helper method to format file size
  getFormattedFileSize() {
    if (!this.FileSize) return 'Unknown';
    return formatBytes(this.FileSize);
  }

  // Helper method to format dates
  getFormattedCreateTime() {
    return this.CreateTime ? this.CreateTime.local().format('L LTS') : '';
  }

  getFormattedUpdateTime() {
    return this.UpdateTime ? this.UpdateTime.local().format('L LTS') : '';
  }
}